// extracted by mini-css-extract-plugin
export default {"wrapper":"Styles_wrapper__CHsEx","card":"Styles_card__d6oln","err":"Styles_err__hqF9e"};